// PaymentGatewayIntegration.js (Refactored)
import React, { Component } from "react";
import { initialIntegrationsData } from "./integartionHelper";
import {
  Section,
  SectionHeader,
  Grid,
  IntegrationCard,
  Button,
} from "./DynamicIntegrationLayout";

const paymentGatewayIcons = {
  Stripe: "💳",
  Razorpay: "💰",
  Phonepe: "💲",
  Paytm: "💵",
  GPay: "🟢",
  "google pay": "🟢",
};

class PaymentGatewayIntegration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      availableGateways: initialIntegrationsData.paymentGateway.providers || [],
    };
  }

  getIcon = (name) => {
    return paymentGatewayIcons[name] || "🔧";
  };

  handleConfigureClick = (gatewayName) => {
    this.props.history.push(`/integration/phonepe/credentials-verify`, {
      registrationId: this.props.registrationId,
      gateway: gatewayName,
    });
  };

  render() {
    const { availableGateways } = this.state;

    return (
      <Section>
        <SectionHeader title={initialIntegrationsData.paymentGateway.title} />
        <Grid minWidth="300px">
          {availableGateways.map((gateway) => (
            <IntegrationCard
              key={gateway.name}
              icon={this.getIcon(gateway.name)}
              title={gateway.name}
              showToggle={false}
              actions={[
                <Button
                  key="setup"
                  onClick={() => this.handleConfigureClick(gateway.name)}
                  icon="⚙️"
                >
                  Setup
                </Button>,
              ]}
            />
          ))}
        </Grid>
      </Section>
    );
  }
}

export default PaymentGatewayIntegration;